import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  NumberInput,
  NumberInputField,
  Select,
  SimpleGrid,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tr,
  useColorModeValue
} from "@chakra-ui/react";
import axios from "axios";
import { GroupBase } from "chakra-react-select";
import { ArquivoUpload } from "models/arquivo_upload";
import { ContasReceber } from "models/contas_receber";
import { PessoaType } from "models/person_type";
import { OptionType } from "models/select_mode";
import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  MdAdd,
  MdEdit,
  MdMail,
  MdPrint,
  MdSave,
  MdUpload
} from "react-icons/md";

import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { Select as AutoComplete } from "chakra-react-select";
import { AccountType } from "models/account_type";
import { CentroCusto } from "models/centro_custo_type";
import { ClientClassificationType } from "models/client_classification_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContaFinanceiro } from "models/conta_financeiro";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { UsuarioModel } from "models/user_model";
import moment from "moment";
import formatNumber from "views/admin/order/hooks/formatNumber";
import LancamentoTable from "./LancamentoTable";

interface IFormContasReceber {
  show: boolean;
  showModal: (show: boolean) => void;
  accountSelected: ContasReceber;
  clientes: PessoaType[];
  showFormPessoa: (show: boolean) => void;
  editPessoa: (item: PessoaType) => void;
  save: (list: any) => void;
  selectedCliente: PessoaType;
  selectedCentroCusto: CentroCusto;
  selectedDepto: ClientClassificationType;
  selectedCondicaoPagamentos: CondicaoPagamento;
  changeCliente: (item: string) => void;
  changeCentroCusto: (item: string) => void;
  changeCondicaoPagamento: (item: string) => void;
  changeDepto: (item: string) => void;
  changeInput: (value: any, type: string) => void;
  textColor: string;
  brandStars: string;
  uploadPictures: (list: any[]) => Promise<ArquivoUpload[]>;
  loading: boolean;
  getLink: (id: string) => void;
  changeFiliais: (item: string) => void;
  filiais: PessoaType[];
  selectedFilial: PessoaType;
  categoria: AccountType[];
  itemList: LancamentoFinanceiro[];
  addRowItem: (item: LancamentoFinanceiro) => void;
  editRowItem: (item: LancamentoFinanceiro) => void;
  deleteRow: (item: LancamentoFinanceiro) => void;
  user: UsuarioModel;
  depto: ClientClassificationType[];
  condicaoPagamento: CondicaoPagamento[];
  centroCusto: CentroCusto[];
  generateParcela: (
    item: string,
    vencimento: Date,
    valor: number,
    fornecedor: string,
    tipoRecebimento: string,
  ) => void;
  changeConta: (item: string) => void;
  contaFinanceiroLista: ContaFinanceiro[];
  selectedConta: ContaFinanceiro;
  changeUser: (item: string) => void;
  selectedUser: UsuarioModel;
  users: UsuarioModel[];
}

const FormContasReceber = ({
  accountSelected,
  clientes,
  editPessoa,
  save,
  show,
  showFormPessoa,
  showModal,
  selectedCliente,
  changeCliente,
  brandStars,
  changeInput,
  getLink,
  loading,
  textColor,
  uploadPictures,
  changeFiliais,
  filiais,
  selectedFilial,
  categoria,
  addRowItem,
  deleteRow,
  editRowItem,
  itemList,
  user,
  changeCentroCusto,
  changeCondicaoPagamento,
  changeDepto,
  selectedCentroCusto,
  selectedCondicaoPagamentos,
  selectedDepto,
  depto,
  condicaoPagamento,
  centroCusto,
  changeConta,
  contaFinanceiroLista,
  generateParcela,
  selectedConta,
  changeUser,
  selectedUser,
  users
}: IFormContasReceber) => {
  const [arquivoLista, setArquivoLista] = useState<any[]>([]);
  const onDrop = useCallback(
    (acceptedFiles: any) => {
      const list = [...arquivoLista];
      acceptedFiles?.forEach((file: { path: string }) => {
        const existe = list.find((f) => f.path === file?.path);
        if (!existe) {
          list.push(file);
        }
      });
      setArquivoLista(list);
    },

    [arquivoLista]
  );

  const removeFile = async (arquivo: any) => {
    if (arquivo?.remote) {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + "/contas-receber/arquivo/" + arquivo?.id
      );
      console.log(response.data);
    }
    const newFile = arquivoLista.filter((arq) => arq !== arquivo);
    setArquivoLista(newFile);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const bg = useColorModeValue("gray.100", "navy.700");
  const borderColor = useColorModeValue("secondaryGray.100", "whiteAlpha.100");

  useEffect(() => {
    if (accountSelected?.id !== undefined) {
      const newArray: any[] = [];
      accountSelected?.ContasReceberArquivo?.forEach((arquivo) => {
        const itemData = {
          name: arquivo?.arquivo?.fileName,
          remote: true,
          id: arquivo.arquivo.id,
        };
        newArray.push(itemData);
      });

      setArquivoLista(newArray);
    } else {
      setArquivoLista([]);
    }
  }, [accountSelected]);

  return (
    <Box w={"100%"} h={"100%"}>

      <Box
        px="0px"
        mb="16px"
        mt="0px"
        justifyContent="space-between"
        ml={4}
      >
        <Stack direction="row" spacing={4}>
          <Button
            leftIcon={<MdMail />}
            colorScheme="brand"
            size={"sm"}
            variant="solid"
          >
            Enviar
          </Button>
          <Button
            leftIcon={<MdPrint />}
            colorScheme="brand"
            size={"sm"}
            variant="solid"
          >
            Imprimir
          </Button>

          <Button
            leftIcon={<MdSave />}
            colorScheme="brand"
            size={"sm"}
            variant="solid"
            isLoading={loading}
            onClick={() => save(arquivoLista)}
          >
            Salvar
          </Button>
        </Stack>
      </Box>

      <SimpleGrid columns={3} spacing={4} mt={24}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Cliente<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <Box w={"82%"}>
              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size={"md"}
                onChange={(e) => {
                  changeCliente(e.value);
                  if (
                    accountSelected?.valor &&
                    accountSelected?.vencimento &&
                    selectedCondicaoPagamentos &&
                    accountSelected?.tipoRecebimento
                  ) {
                    generateParcela(
                      selectedCondicaoPagamentos.id,
                      accountSelected.vencimento,
                      accountSelected?.valor,
                      e.value,
                      accountSelected?.tipoRecebimento
                    );
                  }
                }}
                placeholder="Buscar..."
                isDisabled={false}
                name={"cliente"}
                value={{
                  label: clientes?.find((f) => f.id === selectedCliente?.id)
                    ?.nome,
                  value: selectedCliente?.id,
                }}
                options={clientes?.map((item) => {
                  return {
                    label: item?.nome,
                    value: item?.id,
                  };
                })}
              />
            </Box>
            <IconButton
              colorScheme="brand"
              variant="solid"
              mt={-10}
              borderRadius={8}
              mr={12}
              size={"md"}
              icon={<MdAdd />}
              onClick={() => showFormPessoa(true)}
              float={"right"}
              aria-label={"Adicionar Cliente"}
            />
            <IconButton
              colorScheme="brand"
              variant="solid"
              size={"md"}
              mt={-10}
              ml={0}
              borderRadius={8}
              icon={<MdEdit />}
              onClick={() => {
                editPessoa(selectedCliente);
              }}
              float={"right"}
              aria-label={"Editar Contato"}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Empresa Saída/Filial
          </FormLabel>

          <Select
            size="md"
            onChange={(e) => changeFiliais(e.target.value)}
            defaultValue={accountSelected?.empresaSaiadaId}
          >
            <option value={"0"}>
              SELECIONE A EMPRESA PARA FATURAMENTO
            </option>
            {filiais?.map((item) => (
              <option value={item.id}>{item.nome}</option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={"black"}
            mb="8px"
          >
            Usuário Responsável
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Responsável"
            isRequired={true}
            name={"executivo"}
            onChange={(e) => {
              changeUser(e.value);
            }}
            options={users?.map((item) => {
              return {
                label: item.nome,
                value: item.id,
              };
            })}
            defaultValue={{
              label: selectedUser?.nome,
              value: selectedUser?.id,
            }}
          />
        </FormControl>


      </SimpleGrid>

      <SimpleGrid columns={4} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Número do Documento
          </FormLabel>
          <NumberInput
            min={0}
            onChange={(e: string) => {
              changeInput(e, "documento");
            }}
            defaultValue={accountSelected?.documento}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Departamento<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => changeDepto(e.value)}
              placeholder="Buscar..."
              isDisabled={false}
              name={"fornecedor"}
              value={{
                label: depto?.find((f) => f.id === selectedDepto?.id)?.nome,
                value: selectedDepto?.id,
              }}
              options={depto?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Centro de Custos<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => changeCentroCusto(e.value)}
              placeholder="Buscar..."
              isDisabled={false}
              name={"fornecedor"}
              value={{
                label: centroCusto?.find(
                  (f) => f.id === selectedCentroCusto?.id
                )?.nome,
                value: selectedCentroCusto?.id,
              }}
              options={centroCusto?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Origem
          </FormLabel>

          <Select
            size="md"
            onChange={(e) => changeInput(e.target.value, "origem")}
            defaultValue={accountSelected?.origem}
          >
            <option value={"0"}>SELECIONE A ORIGEM</option>
            <option value={"1"}>AVULSO</option>
            <option value={"2"}>PROJETO</option>
          </Select>
        </FormControl>
      </SimpleGrid>

      <SimpleGrid columns={5} spacing={4} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Emissão
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={
              accountSelected?.emissao !== undefined
                ? new Date(accountSelected?.emissao)
                : new Date()
            }
            onDateChange={(date: any) => {
              changeInput(date, "emissao");
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Vencimento
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            minDate={new Date(moment(new Date()).format("YYYY-MM-DD"))}
            date={
              accountSelected?.vencimento !== undefined
                ? new Date(accountSelected?.vencimento)
                : new Date()
            }
            onDateChange={(date: any) => {
              changeInput(date, "vencimento");
              if (
                selectedCondicaoPagamentos &&
                accountSelected?.valor &&
                selectedCliente &&
                accountSelected?.tipoRecebimento
              ) {
                generateParcela(
                  selectedCondicaoPagamentos.id,
                  date,
                  accountSelected?.valor,
                  selectedCliente?.id,
                  accountSelected?.tipoRecebimento
                );
              }
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Valor
          </FormLabel>
          <NumberInput
            precision={2}
            min={0}
            onBlur={(e) => {
              if (
                selectedCondicaoPagamentos &&
                accountSelected.vencimento &&
                selectedCliente &&
                accountSelected?.tipoRecebimento
              ) {
                generateParcela(
                  selectedCondicaoPagamentos.id,
                  accountSelected.vencimento,
                  Number(e.target.value),
                  selectedCliente?.id,
                  accountSelected?.tipoRecebimento
                );
              }
            }}
            onChange={(e: string) => {
              changeInput(Number(e), "valor");
            }}
            defaultValue={accountSelected?.valor}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Conta para Baixa<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => {
                changeConta(e.value);
              }}
              placeholder="Buscar..."
              isDisabled={false}
              name={"contaFinanceiroLista"}
              defaultValue={{
                label: contaFinanceiroLista?.find(
                  (f) => f.id === selectedConta?.id
                )?.descricao,
                value: selectedConta?.id,
              }}
              options={contaFinanceiroLista?.map((item) => {
                return {
                  label: item?.descricao,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
          >
            Forma de Pagamento<Text color={brandStars}>*</Text>
          </FormLabel>
          <Box alignSelf={"flex-start"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"md"}
              onChange={(e) => {
                generateParcela(
                  e.value,
                  accountSelected?.vencimento,
                  accountSelected?.valor,
                  selectedCliente?.id,
                  accountSelected?.tipoRecebimento
                );
              }}
              placeholder="Buscar..."
              isDisabled={false}
              name={"condicaoPagamento"}
              defaultValue={{
                label: condicaoPagamento?.find(
                  (f) => f.id === selectedCondicaoPagamentos?.id
                )?.nome,
                value: selectedCondicaoPagamentos?.id,
              }}
              options={condicaoPagamento?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
            />
          </Box>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Tipo de Entrada
          </FormLabel>

          <Select
            size="md"
            onChange={(e) =>
              changeInput(e.target.value, "tipoLancamentoId")
            }
            defaultValue={accountSelected?.tipoLancamentoId}
          >
            <option value={"0"}>SELECIONE A CONTA</option>
            {categoria?.map((item) => (
              <option value={item.id}>{item.descricao}</option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Status
          </FormLabel>

          <Select
            size="md"
            onChange={(e) => changeInput(e.target.value, "status")}
            defaultValue={accountSelected?.status}
          >
            <option value={"0"}>SELECIONE O STATUS</option>
            <option value={"1"}>Á RECEBER</option>
            <option value={"2"}>RECEBIDO</option>
            <option value={"3"}>PARCIAL</option>
            <option value={"4"}>CANCELADO</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Regime Contábil
          </FormLabel>

          <Select
            size="md"
            onChange={(e) => changeInput(e.target.value, "regime")}
            defaultValue={accountSelected?.regime}
          >
            <option value={"0"}>SELECIONE O REGIME CONTÁBIL</option>
            <option value={"1"}>COMPETÊNCIA</option>
            <option value={"2"}>CAIXA</option>
            <option value={"3"}>MANUAL</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Forma de Recebimento
          </FormLabel>

          <Select
            size="md"
            onChange={(e) =>
              changeInput(e.target.value, "formaRecebimento")
            }
            defaultValue={accountSelected?.formaRecebimento}
          >
            <option value={"0"}>SELECIONE A FORMA DE RECEBIMENTO</option>
            <option value={"1"}>MANUAL</option>
            <option value={"2"}>AUTOMÁTICA</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            color={textColor}
            mb="8px"
          >
            Tipo de Recebimento
          </FormLabel>

          <Select
            size="md"
            onChange={(e) => {
              changeInput(e.target.value, "tipoRecebimento");
              generateParcela(
                selectedCondicaoPagamentos.id,
                accountSelected.vencimento,
                accountSelected?.valor,
                selectedCliente?.id,
                e.target.value
              );
            }}
            defaultValue={accountSelected?.tipoRecebimento}
          >
            <option value={"0"}>SELECIONE O TIPO DE RECEBIMENTO</option>
            <option value={"1"}>BOLETO</option>
            <option value={"2"}>CHEQUE</option>
            <option value={"3"}>CARTÃO</option>
            <option value={"4"}>DINHEIRO</option>
            <option value={"5"}>DEPÓSITO</option>
            <option value={"6"}>DÉBITO EM CONTA</option>
            <option value={"7"}>FATURA</option>
            <option value={"8"}>ARRECADAÇÃO/RECEBIMENTO</option>
            <option value={"9"}>TRANSFÊRENCIA</option>
            <option value={"10"}>PIX</option>
          </Select>
        </FormControl>
      </SimpleGrid>

      <Text
        mt={8}
        fontSize={18}
        color={"#422AFB"}
        fontWeight={"bold"}
        mb={4}
      >
        Lançamentos -{" "}
        {formatNumber(
          itemList.reduce((value, acc) => (Number(acc.valor) - Number(acc.desconto) + Number(acc.acrescimo)) + value, 0)
        )}
      </Text>
      <LancamentoTable
        itemList={itemList}
        addRowItem={addRowItem}
        editRowItem={editRowItem}
        deleteRow={deleteRow}
        borderColor={borderColor}
        textColor={textColor}
        selectedCliente={selectedCliente}
        user={user}
        tipo={true}
      />

      <SimpleGrid spacing={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="500"
            mt={4}
            color={textColor}
          >
            Observação<Text color={brandStars}>*</Text>
          </FormLabel>
          <Textarea
            defaultValue={accountSelected?.observcao}
            fontSize="sm"
            height={200}
            ms={{ base: "0px", md: "0px" }}
            placeholder="Preencha a Observação"
            onBlur={(e) => {
              changeInput(e.target.value, "observcao");
            }}
            fontWeight="500"
            size="md"
          />
        </FormControl>
      </SimpleGrid>

      <Flex
        align="center"
        justify="center"
        bg={bg}
        mt={4}
        border="1px dashed"
        borderColor={borderColor}
        borderRadius="16px"
        w="100%"
        h={200}
        minH="100%"
        cursor="pointer"
        {...getRootProps({ className: "dropzone" })}
      >
        <input {...getInputProps()} />
        <Button variant="no-effects" leftIcon={<MdUpload />}>
          Enviar Arquivos
        </Button>
      </Flex>
      <Table variant="striped" color="gray.500" mb="24px" mt="12px">
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #ARQUIVO
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OPÇÕES
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {arquivoLista?.map((arquivo) => (
            <Tr>
              {arquivo?.remote !== undefined ? (
                <Td>
                  <a
                    href={process.env.REACT_APP_API_URL + `/arquivo/${arquivo?.id}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "blue",
                      textDecoration: "underline",
                    }}
                  >
                    {arquivo?.name}
                  </a>
                </Td>
              ) : (
                <Td>{arquivo?.name}</Td>
              )}
              <Td>
                <Button
                  onClick={() => {
                    removeFile(arquivo);
                  }}
                  colorScheme="red"
                  variant="ghost"
                  ml="1"
                >
                  Excluir
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default FormContasReceber;
